import { useCallback } from 'react';

import { convertWeiToEthers } from '@/utils/convertValueToWei';

import { useCalculateLtv } from './useCalculateLTV';

export const useDisplayLTV = (floorPriceInWei = false) => {
  const calculateLtv = useCalculateLtv();
  return useCallback(
    (principal: number | null, floorPrice: number | null | undefined, currency: string | undefined) =>
      floorPrice && principal && currency
        ? `${calculateLtv(principal, floorPriceInWei ? convertWeiToEthers(floorPrice) : floorPrice, currency)
            .toString()
            .slice(0, 5)}%`
        : 'N/A',
    [calculateLtv, floorPriceInWei]
  );
};
